import React from 'react';
import { Sparkles, Backpack, Award, Gamepad2 } from 'lucide-react';
import { ViewType } from '../types';

interface MobileNavProps {
  currentView: ViewType;
  onNavigate: (view: ViewType) => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ currentView, onNavigate }) => {
  const items: { view: ViewType; label: string; icon: React.ReactNode; activeColor: string }[] = [
    {
      view: 'home',
      label: 'Đấu trường',
      icon: <Gamepad2 className="w-5 h-5" />,
      activeColor: 'text-[#ffd166] bg-[#ffb703]/20 border-[#ffd166]/50',
    },
    {
      view: 'journey',
      label: 'Balo Săn Tem',
      icon: <Backpack className="w-5 h-5" />,
      activeColor: 'text-[#ff708f] bg-[#ff3366]/20 border-[#ff708f]/50',
    },
    {
      view: 'summary',
      label: 'Thẻ Kiện Tướng',
      icon: <Award className="w-5 h-5" />,
      activeColor: 'text-[#c084fc] bg-[#8b5cf6]/20 border-[#c084fc]/50',
    },
  ];

  return (
    <nav
      aria-label="Điều hướng di động"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#190c1e]/96 backdrop-blur-xl border-t-2 border-[#ffb703]/30 pb-[max(0.5rem,env(safe-area-inset-bottom,8px))] shadow-[0_-8px_24px_rgba(0,0,0,0.6)]"
    >
      <div className="grid grid-cols-3 h-15 px-3 py-1">
        {items.map(({ view, label, icon, activeColor }) => {
          const isActive = currentView === view;
          return (
            <button
              key={view}
              onClick={() => onNavigate(view)}
              className={`flex flex-col items-center justify-center gap-1 rounded-2xl py-1 transition-all active:scale-95 ${
                isActive
                  ? `${activeColor} border shadow-md font-black`
                  : 'text-[#d8c4b8] hover:text-white font-bold'
              }`}
            >
              <span className={`transition-transform duration-200 ${isActive ? 'scale-115 -translate-y-0.5' : ''}`}>
                {icon}
              </span>
              <span className="text-[11px] tracking-wide">
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
